export default __webpack_public_path__ + "static/media/close.13bf2eb7.svg";